import { TextField } from "@mui/material";
import React from "react";
import { useEffect, useState } from "react"
import { NavLink } from "react-router-dom";
import Invoice1 from "../components/InvoiceForPriting";

export default function InvoicePage() {
    // =========>> Constant
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();
    let monthYearCreate = currentMonth.toString() + currentYear.toString();
    const [monthYear, setMonthYear] = useState(currentMonth.toString() + currentYear.toString());

    const [isMonthlyReportAvailable, setIsMonthlyReportAvailable] = useState(true);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [roomInvalid, setRoomInvalid] = useState(false);
    const [building, setBuilding] = useState('');
    const [room_number, setRoom_number] = useState('');
    const [errorSubmit, setErrorSubmit] = useState(false);
    const [triggerDownload, setTriggerDownload] = useState(false); 
    const [openBuildingInput, setOpenBuildingInput] = useState(false);
    const [openRoomInput, setOpenRoomInput] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState(false);
    const handleCheckMonthlyReportAvailable = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/monthly-report/check-exisiting-record?monthYear=${monthYear}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                setError(true);
                setErrorMessage('មិនអាចទទួលទិន្នន័យពី server');
            }

            const data = await response.json();
            const extractData = data.message;
            if (extractData) {
                setLoading(false);
            } 
            setIsMonthlyReportAvailable(extractData);
        } catch (err) {
            console.error(err.message);
            setError(true);
            setErrorMessage('មិនអាចទទួលទិន្នន័យពី server');
        }
    }

    useEffect(() => {
        handleCheckMonthlyReportAvailable();
    }, [monthYear]);

    const handleCreateMonthlyReport = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/monthly-report`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                setError(true);
                setErrorMessage('មិនជោគជ័យ');
            }
            
            handleCheckMonthlyReportAvailable();

        } catch (err) {
            console.error(err.message);
            setError(true);
            setErrorMessage('មិនជោគជ័យ');
        }
    }

    const handleDownloadInvoicePreviousMonth = (e) => {
        let previousMonth = currentMonth - 1;
        let previousYear = currentYear;
        
        if (previousMonth === 0) {
            previousMonth = 12;
            previousYear -= 1;
        }
        monthYearCreate = previousMonth.toString() + previousYear.toString();
        setMonthYear(previousMonth.toString() + previousYear.toString());
        setSelected(true);
    }

    const handleDownloadAll = (e) => {
        e.preventDefault();
        setBuilding('');
        setRoom_number('');
        handleDownloadInvoice(e);
    }

    const handleOpenBuildingInput = (e) => {
        e.preventDefault();
        if (openBuildingInput == true) {
            setOpenBuildingInput(false);
        } else {
            setOpenBuildingInput(true);
            setOpenRoomInput(false);
            setTriggerDownload(false);
            setRoom_number('');
        }
    }

    const handleOpenRoomInput = (e) => {
        e.preventDefault();
        if (openRoomInput == true) {
            setOpenRoomInput(false);
        } else {
            setOpenRoomInput(true);
            setOpenBuildingInput(false);
            setTriggerDownload(false);
            setBuilding('');
        }
    }
      
    const handleDownloadInvoice = (e) => {
        e.preventDefault();
        // if (!building) {
        //     setErrorSubmit(true);
        //     return;
        // }
        setErrorSubmit(false);
        setTriggerDownload(true); // Trigger download in Invoice1
    };

    return (
        <div className="w-full h-[100dvh] bg-white">
            {/* Header */}
            <div className="w-full h-[8dvh] bg-primary2 flex  items-center">
                <div className="md:w-[8%] pl-3 md:pl-10 items-center flex text-customWhite">
                    <NavLink to='/'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                        </svg>
                    </NavLink>
                </div>
                <div className="w-[84%] flex justify-center">
                    <h2 className="text-2xl font-semibold text-customWhite">វិក័យប័ត្រ</h2>
                </div>
            </div>

            {/* Body */}
            <div className="w-full">
                {
                    isMonthlyReportAvailable === false ? (
                        <div className="w-full">
                            {
                                error ? (
                                    <div className="w-full h-[92dvh] flex items-center justify-center text-red-600 font-semibold text-2xl">
                                        {errorMessage}
                                    </div>
                                ) : (
                                    <div className="w-full h-[92dvh] flex flex-col justify-center items-center text-2xl">
                                        <div className="md:space-y-10 flex flex-col">
                                            <h3 className="text-center font-medium">បញ្ជីទូទាត់ប្រាក់សម្រាប់ខែ {currentMonth} នៅមិនទាន់បង្កើតនៅឡើយ!</h3>
                                            <div className="flex flex-col md:flex-row space-y-5 md:space-y-0 mt-5 md:mt-0">
                                                <NavLink to='/' className="flex justify-center">
                                                    <button
                                                        type="button"
                                                        className="px-24 md:px-20 py-1 md:py-4 text-lg md:text-2xl font-medium bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 mr-3"
                                                    >
                                                        ថយក្រោយ
                                                    </button>
                                                </NavLink>
                                                <div className="flex justify-center">
                                                    <button
                                                    disabled={loading}
                                                    type="submit"
                                                    className={`px-24 md:px-28 py-1 md:py-4 text-lg md:text-2xl font-medium bg-primary2 text-white  rounded-lg hover:bg-primary1 md:ml-3 ${loading ? 'opacity-75 cursor-not-allowed' : ''}`}
                                                    onClick={handleCreateMonthlyReport}
                                                    >
                                                        {loading ? "បង្កើតឥឡូវនេះ..." : "បង្កើតឥឡូវនេះ"}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="flex justify-center">
                                                <button
                                                    disabled={loading}
                                                    type="submit"
                                                    className={`mt-5 md:mt-0 px-14 md:px-28 py-1 md:py-4 text-lg md:text-2xl font-medium bg-secondary1 text-white  rounded-lg hover:bg-primary2 md:ml-3 ${loading ? 'opacity-75 cursor-not-allowed' : ''}`}
                                                    onClick={handleDownloadInvoicePreviousMonth}
                                                    >
                                                        ទាញយកវិក័យប័ត្រខែចាស់
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    ) : (
                        <div className="w-full h-[82dvh] flex flex-col justify-center items-center text-2xl">
                            <button
                                type="submit"
                                className={`h-14 ${selected ? "bg-primary1" : "bg-secondary1"} hover:bg-primary2 font-medium text-white px-12 ml-5 rounded-lg duration-200 mb-10`}
                                onClick={handleDownloadInvoicePreviousMonth}
                                >
                                    ទាញយកវិក័យប័ត្រខែចាស់
                            </button>
                            <div className="mb-10 space-y-10 md:space-y-0 md:space-x-10 flex flex-col md:flex-row">
                                <button 
                                    onClick={handleDownloadAll} className="h-14 bg-primary2 font-medium text-white px-12 ml-5 rounded-lg duration-200">
                                    ទាញយកទាំងអស់
                                </button>
                                <button 
                                    onClick={handleOpenBuildingInput} className="h-14 bg-primary2 font-medium text-white px-12 ml-5 rounded-lg duration-200">
                                    ទាញយកតាមអគារ
                                </button>
                                <button 
                                    onClick={handleOpenRoomInput} className="h-14 bg-primary2 font-medium text-white px-12 ml-5 rounded-lg duration-200">
                                    ទាញយកតាមបន្ទប់
                                </button>
                            </div>
                            <div className="space-y-10">
                                {/* <h3 className="text-center font-medium">សូមជ្រើសរើសអគារ ឬបន្ទប់ដើម្បីទាញយកវិក័យប័ត្រ!</h3> */}
                                {openBuildingInput && (
                                    <div>
                                        <form className="flex w-[100%] items-center flex-col space-y-10" onSubmit={handleDownloadInvoice}>
                                            <div className="flex space-x-5">
                                                <TextField
                                                    margin="dense"
                                                    label="អគារ *"
                                                    name="building"
                                                    value={building}
                                                    onChange={(e) => setBuilding(e.target.value)} 
                                                    fullWidth
                                                    InputLabelProps={{
                                                        style: { fontFamily: 'Kantumruy Pro',
                                                            fontSize: '20px' },
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                        borderRadius: "8px",
                                                        fontFamily: 'Kantumruy Pro',
                                                        fontSize: '20px'
                                                        }
                                                    }}
                                                />
                                            </div>
                                            {
                                                errorSubmit === true ?? <p className="text-red-600">សូមជ្រើសរើសអគារ</p>
                                            }
                                            {
                                                roomInvalid ?? <p className="text-red-600">សូមជ្រើសរើសអគារ</p>
                                            }
                                            <button 
                                                type="submit" className="h-14 bg-primary2 font-medium text-white px-12 ml-5 rounded-lg duration-200">
                                                {error ? 'សូមរង់ចាំ...' : 'ទាញយក'}
                                            </button>
                                        </form>
                                    </div>)
                                }
                                {openRoomInput && (
                                    <div>
                                        <form className="flex w-[100%] items-center flex-col space-y-10" onSubmit={handleDownloadInvoice}>
                                            <div className="flex space-x-5">
                                                <TextField
                                                    margin="dense"
                                                    label="លេខបន្ទប់ *"
                                                    name="building"
                                                    value={room_number}
                                                    onChange={(e) => setRoom_number(e.target.value)} 
                                                    fullWidth
                                                    InputLabelProps={{
                                                        style: { fontFamily: 'Kantumruy Pro',
                                                            fontSize: '20px' },
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                        borderRadius: "8px",
                                                        fontFamily: 'Kantumruy Pro',
                                                        fontSize: '20px'
                                                        }
                                                    }}
                                                />
                                            </div>
                                            {
                                                errorSubmit === true ?? <p className="text-red-600">សូមជ្រើសរើសលេខបន្ទប់</p>
                                            }
                                            {
                                                roomInvalid ?? <p className="text-red-600">សូមជ្រើសរើសលេខបន្ទប់</p>
                                            }
                                            <button 
                                                type="submit" className="h-14 bg-primary2 font-medium text-white px-12 ml-5 rounded-lg duration-200">
                                                {error ? 'សូមរង់ចាំ...' : 'ទាញយក'}
                                            </button>
                                        </form>
                                    </div>)
                                }
                            </div>
                        </div>
                    )
                }  {triggerDownload && <Invoice1 building={building} monthYear={monthYear} room_number={room_number} x={true} onDownloadComplete={() => setTriggerDownload(false)} />}
            </div>
        </div>
        
    )
}